import { Skeleton } from '@/components/ui/skeleton';

export function TablePagerSkeletonLoader() {
  return (
    <div className="flex items-center justify-end px-2">
      <div className="mr-auto flex items-center space-x-6 lg:space-x-8">
        <Skeleton className="h-4 w-[85px]" />
      </div>
      <div className="flex items-center space-x-6 lg:space-x-8">
        <div className="flex items-center space-x-2">
          <Skeleton className="h-4 w-[98px]" />
          <Skeleton className="h-8 w-[70px]" />
        </div>
        <div className="flex w-[100px] items-center justify-center">
          <Skeleton className="h-4 w-[90px]" />
        </div>
        <div className="flex items-center space-x-2">
          <Skeleton className="hidden h-8 w-8 lg:flex" />
          <Skeleton className="h-8 w-8" />
          <Skeleton className="h-8 w-8" />
          <Skeleton className="hidden h-8 w-8 lg:flex" />
        </div>
      </div>
    </div>
  );
}
